/** Formatadores pt-BR da apuração semanal — equivalentes aos do protótipo HTML. */

const nf = new Intl.NumberFormat("pt-BR", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const brl = (n) => (n < 0 ? "−" : "") + "R$ " + nf.format(Math.abs(n));
export const num = (n) => (n < 0 ? "−" : "") + nf.format(Math.abs(n));
export const dash = (n) => (Math.abs(n) < 0.005 ? "–" : num(n));

export const pct = (x, d) =>
  (x * 100).toLocaleString("pt-BR", {
    minimumFractionDigits: d == null ? 1 : d,
    maximumFractionDigits: d == null ? 1 : d,
  }) + "%";

export const compact = (n) => {
  const a = Math.abs(n);
  const s = n < 0 ? "−" : "";
  if (a >= 1e6)
    return s + (a / 1e6).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " mi";
  if (a >= 1e3)
    return s + (a / 1e3).toLocaleString("pt-BR", { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + " mil";
  return s + nf.format(a);
};

/** Parse pt-BR ("1.234,56" / "-1234.56") para número. */
export function parseNum(s) {
  s = (s || "").trim().replace(/\s/g, "");
  if (!s) return 0;
  const neg = s.charAt(0) === "-";
  s = s.replace(/[^0-9,.]/g, "");
  if (s.indexOf(",") >= 0) s = s.replace(/\./g, "").replace(",", ".");
  else if (/^\d{1,3}(\.\d{3})+$/.test(s)) s = s.replace(/\./g, "");
  const n = parseFloat(s);
  return isNaN(n) ? 0 : neg ? -n : n;
}
